var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c("textarea", { ref: "codeMirrorRef" }, [_vm._v(_vm._s(_setup.value))])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }